import { ThemeProvider, Toaster, paguzTheme } from '@paguz/ui';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { useState } from 'react';
import { createQueryClient } from './api/query-client.ts';
import { createAppRouter } from './router.tsx';

export function App({ queryClient: provided }: { queryClient?: QueryClient } = {}) {
  const [queryClient] = useState(() => provided ?? createQueryClient());
  const [router] = useState(() => createAppRouter(queryClient));
  return (
    <ThemeProvider theme={paguzTheme} global>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster position="top-center" />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
